/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_House_RulesInputs */

const en_doc_type_house_rules = /** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House Rules`)
};

const id_doc_type_house_rules = /** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan Rumah`)
};

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const es_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const fr_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const de_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const ja_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const zh_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const ar_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const it_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const ru_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const pt_doc_type_house_rules = en_doc_type_house_rules;

/** @type {(inputs: Doc_Type_House_RulesInputs) => LocalizedString} */
const ko_doc_type_house_rules = en_doc_type_house_rules;

/**
* | output |
* | --- |
* | "House Rules" |
*
* @param {Doc_Type_House_RulesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_house_rules = /** @type {((inputs?: Doc_Type_House_RulesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_House_RulesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_house_rules(inputs)
	if (locale === "es") return es_doc_type_house_rules(inputs)
	if (locale === "fr") return fr_doc_type_house_rules(inputs)
	if (locale === "de") return de_doc_type_house_rules(inputs)
	if (locale === "ja") return ja_doc_type_house_rules(inputs)
	if (locale === "zh") return zh_doc_type_house_rules(inputs)
	if (locale === "ar") return ar_doc_type_house_rules(inputs)
	if (locale === "id") return id_doc_type_house_rules(inputs)
	if (locale === "it") return it_doc_type_house_rules(inputs)
	if (locale === "ru") return ru_doc_type_house_rules(inputs)
	if (locale === "pt") return pt_doc_type_house_rules(inputs)
	return ko_doc_type_house_rules(inputs)
});